import TemplatesDetailsController from './controllers/pages/details-controller';
import TemplatesListController from './controllers/pages/list-controller';

import detailsTemplate from './views/pages/details.tpl.html';
import listTemplate from './views/pages/list.tpl.html';

angular
    .module('festzelt-os.modules.templates')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.templates', {
            abstract: true,
            url: '/templates',
            template: '<ui-view/>'
        })
        .state('app.templates.index', {
            url: '',
            params: {
                startTab: {
                    type: 'string',
                    value: 'shared'
                }
            },
            data: {
                rights: 'templates::list'
            },
            controller: TemplatesListController,
            controllerAs: 'vm',
            templateUrl: listTemplate
        })
        .state('app.templates.details', {
            url: '/{id}',
            params: {
                id: {
                    type: 'int'
                }
            },
            data: {
                bodyClass: 'wide',
                rights: 'templates::view'
            },
            controller: TemplatesDetailsController,
            controllerAs: 'vm',
            templateUrl: detailsTemplate
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/templates/routes.js